import React from 'react';
import {useNavigate, useLocation, useParams} from 'react-router-dom';

export const withRouter = (Component) => {
  function Wrapper(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    navigate.withParams = (path) => navigate(`${path}${location.search}`);

    return (
      <Component
        {...props}
        location={location}
        navigate={navigate}
        params={params}
      />
    );
  }

  return Wrapper;
};
